<template>
  <div v-if="allTasks.length">
    <hr class="mt-2 calendar-hr" />
    <h6 class="text-muted">{{ date.date | moment("ddd DD") }}</h6>

    <ul class="mb-2 list-group text-dark">
      <li v-for="task in allTasks" :key="task.id" class="list-group-item js-task-details-collapse-container">
        <QuickTask :task="task" />
      </li>
    </ul>
  </div>
</template>

<script>
import QuickTask from "components/QuickTask";
import moment from 'moment';

export default {
  components: {
    QuickTask
  },
  computed: {
    allTasks: function(){
      var date = moment(this.date.date).format('YYYY-MM-DD')
      var journal = this.journal;
      return this.$store.state.tasks.filter(function (task){
        return (moment(task.completed_at).format('YYYY-MM-DD') == date && (task.completed === true & task.journaled === journal))
      })
    }
  },
  props: {
    date: {
      type: Object
    },
    journal: {
      type: Boolean
    }
  }
}
</script>
